var map = {
	"./de/returnBtn.png": "ubj5",
	"./en/returnBtn.png": "3aoH",
	"./es/returnBtn.png": "AJ+c",
	"./fr/returnBtn.png": "T9Fd",
	"./ja/returnBtn.png": "qwlG",
	"./ko/returnBtn.png": "mwzq",
	"./pt/returnBtn.png": "N1Km",
	"./ru/returnBtn.png": "KRr8",
	"./tc/returnBtn.png": "23O3",
	"./th/returnBtn.png": "tTFR"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QnO8";